import 'slick-carousel';

const tabsCards = ($) => {
	$(document).ready(function () {
		const sliderComponents = document.querySelectorAll(
			'.flexible-tabs_cards--slider'
		);

		function initFlexibleSlider(component) {
			$(component)
				.not('.slick-initialized')
				.slick({
					infinite: false,
					slidesToShow: 3,
					slidesToScroll: 1,
					dots: false,
					prevArrow: component.parentElement.querySelector('.arrow.prev-arrow'),
					nextArrow: component.parentElement.querySelector('.arrow.next-arrow'),

					responsive: [
						{
							breakpoint: 1024,
							settings: {
								slidesToShow: 1.2,
								slidesToScroll: 1,
								infinite: false,
								arrows: false,
							},
						},
					],
				});
		}

		sliderComponents.forEach((component) => {
			initFlexibleSlider(component);
			$(window).on('resize', function () {
				initFlexibleSlider(component);
			});
		});
	});
};

export default tabsCards;
